export default "__VITE_ASSET__BLmZY3bl__"